import { Icon, Icons } from 'components/Icon';
import React, { useCallback, useMemo, useState } from 'react';
import Physical from '../../../../../assets/assets/other-assets.png';
import CircleProgressBar from 'components/CircleProgressBar';
import { PhysicalAsset } from 'service/dto/physical-asset.dto';

export default function PhysicalAssets({
  assets
}: {
  assets: PhysicalAsset[] | undefined;
}) {
  const [isExpand, setIsExpand] = useState(false);

  const totalBeneficiary = useMemo(() => {
    const totalBeneficiary = (assets ?? [])?.reduce(
      (sum, trustee) => sum + trustee.totalBeneficiary,
      0
    );
    return (totalBeneficiary || 0) > 10
      ? totalBeneficiary
      : `0${totalBeneficiary}`;
  }, [assets]);

  const getTrustNames = useCallback(
    (asset: PhysicalAsset[] | undefined): string => {
      const trustees = (asset ?? []).filter(ass => ass.trusteeId);
      if (trustees.length) {
        return trustees
          .map(
            ({ trustee }) =>
              `${
                trustee
                  ? `${trustee.trusteeFirstName ?? ''} ${
                      trustee.trusteeMiddleName ?? ''
                    } ${trustee.trusteeLastName ?? ''}`
                  : ''
              } `
          )
          .join(', ');
      }
      return 'N/A';
    },
    []
  );

  return (
    <div>
      <div className="mt-2 flex flex-col">
        <div className="w-full rounded-md bg-white shadow-sm">
          <div className="border-b border-[#E5E5E5]">
            <div
              tabIndex={-1}
              role="button"
              className="flex items-center justify-between p-3 px-5"
              onClick={() => setIsExpand(prevState => !prevState)}
            >
              <div className="flex items-center gap-3">
                <span className="text-base font-normal text-[#34475E]">
                  Physical Asset{' '}
                </span>
                <span className="h-4 w-4 rounded-full bg-[#FF6600] text-center text-[10px] text-white">
                  {assets?.length}
                </span>
              </div>
              <div className={isExpand ? 'rotate-180' : ''}>
                <Icon name={Icons.ArrowDownCircle} />
              </div>
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-between px-4 pb-1">
            <div className="mr-3 space-y-2">
              <img
                src={Physical}
                className="h-[6.5rem] w-[6.5rem] object-contain"
              />
            </div>
            <div className="my-2 mr-3 space-y-2">
              <div className="font-circular text-sm font-medium text-slate-600">
                Total Account
              </div>
              <div className="font-circular text-xl font-medium text-slate-600">
                {assets && assets?.length < 10
                  ? `0${assets?.length}`
                  : assets?.length}
              </div>
            </div>
            <div className="my-2 mr-3 space-y-2">
              <div className="font-circular text-sm font-medium text-slate-600">
                Added Beneficiary
              </div>
              <div className="font-circular text-xl font-medium text-slate-600">
                {totalBeneficiary}
              </div>
            </div>
            <div className="my-2 mr-3 space-y-2">
              <div className="font-circular text-sm font-medium text-slate-600">
                Assigned Trustee
              </div>
              <div className="font-circular text-xl font-medium text-slate-600">
                {getTrustNames(assets) ?? 'N/A'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {isExpand && (
        <div>
          {(assets ?? []).map((asset, idx) => (
            <div className="mt-2 flex flex-col" key={asset.id}>
              <div className="w-full rounded-md bg-white shadow-sm">
                <div className="bg-[#FF660005]">
                  <div className="ml-5 flex items-center justify-between p-2 px-5">
                    <div className="flex flex-col">
                      <span className="text-base font-normal text-[#FF6606]">
                        Account {idx + 1}
                      </span>
                      <div className="mt-1 flex items-center gap-1 text-sm font-bold text-[#585858]">
                        {asset.assetType}{' '}
                        <Icon name={Icons.Bank} fill="#0000008F" />
                      </div>
                    </div>
                    <div className="mr-9 flex items-center gap-2">
                      <CircleProgressBar
                        progress={asset.percentageAlloted}
                        width={30}
                        height={50}
                      />
                      <div className="flex items-center gap-1 text-base text-[#868686]">
                        <span>{asset.percentageAlloted}%</span>
                        <span>Assigned</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-6 flex flex-wrap items-center justify-between px-4 pb-1">
                  <div className="my-2 mr-3 space-y-2">
                    <div className="font-circular text-[13px] font-normal text-[#7A7C87]">
                      Asset Type
                    </div>
                    <div className="font-circular text-base font-medium text-[#585858]">
                      {asset.assetType}
                    </div>
                  </div>
                  <div className="my-2 mr-3 space-y-2">
                    <div className="font-circular text-[13px] font-normal text-[#7A7C87]">
                      Registration number
                    </div>
                    <div className="font-circular text-base font-medium text-[#585858]">
                      {asset.regNo}
                    </div>
                  </div>
                  <div className="my-2 mr-3 space-y-2">
                    <div className="font-circular text-[13px] font-normal text-[#7A7C87]">
                      Location
                    </div>
                    <div className="font-circular text-base font-medium text-[#585858]">
                      {asset.location}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
